import moment from 'moment';

const filterList = (data, list, field) => {
  if (field === 'range') {
    const {
      start,
      end,
    } = data;

    const startDate = moment(start);
    const endDate = moment(end).endOf('day');

    return list.filter((item) => {
      let notificationDate = item.notification.timestamp;
      if (item.notification.cycleStart) {
        notificationDate = item.notification.cycleStart;
      } else if (item.notification.startTime) {
        notificationDate = item.notification.startTime;
      }
      notificationDate = moment(notificationDate);
      if (startDate.format('M-D-YY') === endDate.format('M-D-YY')) {
        return notificationDate.format('MM-D-YYYY') === startDate.format('MM-D-YYYY');
      }
      return notificationDate.isAfter(startDate) && notificationDate.isBefore(endDate);
    });
  }

  if (field === 'serviceTerritory') {
    return list.filter(item => item.serviceTerritory === data);
  }

  if (field === 'industry') {
    return list.filter(item => item.industry === data);
  }

  if (field === 'alertDate') {
    const date = moment(data).format('MM-D-YYYY');

    return list.filter((item) => {
      if (item.notification) {
        let notificationDate;
        if (item.notification.cycleEnd) {
          notificationDate = item.notification.cycleEnd;
        } else if (item.notification.startTime) {
          notificationDate = item.notification.startTime;
        } else if (item.notification.pressureTime) {
          notificationDate = item.notification.pressureTime;
        }
        return date === moment(notificationDate).format('MM-D-YYYY');
      }

      return false;
    });
  }

  if (field === 'alertCategory') {
    return list.filter(item => item.category === data);
  }

  if (field === 'lastOccurred') {
    const date = moment(data).format('MM-D-YYYY');

    return list.filter((item) => {
      if (item.notification) {
        return date === moment(item.notification.timestamp).format('MM-D-YYYY');
      }

      return false;
    });
  }

  if (field === 'status') {
    return list.filter((item) => {
      if (data === 'archived') {
        return item.notification.resolveStatus === 'Archived';
      }

      if (data === 'released') {
        return item.notification.resolveStatus === 'Released';
      }

      return item.notification.resolveStatus !== 'Archived' && item.notification.resolveStatus !== 'Released';
    });
  }

  if (field === 'type') {
    if (data === 'Supply Air' || data === 'Delta T' || data === 'Delta IO' || data === 'Runtime') {
      return list.filter(item => item.notification.category === data);
    }
    if (data === 'Offline') {
      return list.filter(item => item.notification.strength === data);
    }
    if (data === 'Leak') {
      return list.filter(item => item.notification.message && item.notification.message.includes('water leak'));
    }
    if (data === 'Rapid Pressure Change') {
      return list.filter(item => item.notification.message.includes('Rapid pressure change'));
    }
    if (data === 'Low Pressure') {
      return list.filter(item => item.notification.message.includes('Low pressure'));
    }
    if (data === 'Filter Replaced') {
      return list.filter(item => item.notification.message.includes('Filter seems to be replaced'));
    }
    if (data === 'Filter Life Low') {
      return list.filter(item => item.notification.message.includes('Filter life low'));
    }
    if (data === 'Comfort Battery') {
      return list.filter(item => item.notification.message.includes('Supply Air sensor'));
    }
    if (data === 'Filter Battery') {
      return list.filter(item => item.notification.message.includes('Room Ambient sensor'));
    }
    if (data === 'Water Battery') {
      return list.filter(item => item.notification.message.includes('Attic sensor'));
    }

    return list;
  }

  if (field === 'severity') {
    return list.filter(item => item.notification.type === data);
  }

  if (field === 'deviceType') {
    return list.filter((item) => {
      if (data === 'hub') {
        return item.label === 'Gateway';
      }
      if (data === 'supply') {
        return item.label === 'Supply Air';
      }
      if (data === 'return') {
        return item.label === 'Room Ambient';
      }
      if (data === 'air') {
        return item.label === 'Attic';
      }
      return true;
    });
  }

  if (field === 'age') {
    const currentDate = moment();
    return list.filter((item) => {
      const notificationDate = moment(item.notification.timestamp);
      const difference = currentDate.diff(notificationDate, 'days');
      if (data === '1') {
        return difference <= 10;
      }
      if (data === '2') {
        return difference >= 11 && difference <= 25;
      }
      return difference > 25;
    });
  }

  if (field === 'corporation') {
    return list.filter(item => item.customer && item.customer.companyName === data);
  }

  if (field === 'zoneCycle') {
    return list.filter(item => item.zone === data);
  }

  if (field === 'cycleQualify') {
    return list.filter((item) => {
      const inSeconds = data * 60;
      return item.cycleTimeSeconds >= inSeconds && (item.acMode === 'Cool' || item.acMode === 'Heat');
    });
  }

  if (field === 'cycleStatus') {
    return list.filter((item) => {
      let include = false;
      item.alerts.forEach((alert) => {
        if (alert.type === 'Error') {
          include = true;
        }
      });
      return include;
    });
  }

  if (field === 'cycleType') {
    return list.filter((item) => {
      if (data === 'cool') {
        return item.acMode === 'Cool';
      }
      if (data === 'heat') {
        return item.acMode === 'Heat';
      }
      if (data === 'fan') {
        return item.acMode === 'Fan';
      }
    });
  }

  if (field === 'date') {
    return list.filter((item) => {
      const filterDate = moment(data).format('MM-DD-YYYY');
      let cHub = item.hub;
      if (item.hubs) {
        const [h] = item.hubs;
        cHub = h;
      }
      const itemDate = moment(cHub.creationDate).format('MM-DD-YYYY');
      return filterDate === itemDate;
    });
  }

  if (field === 'cycleDate') {
    return list.filter((item) => {
      const currentDay = moment();
      const cycleDate = moment(item.startTime || item.endTime || item.localDate);
      if (data === 'today') {
        if (currentDay.format('M-DD-YYYY') === cycleDate.format('M-DD-YYYY')) {
          return true;
        }
      } else if (data === 'yesterday') {
        currentDay.subtract(1, 'days');
        if (currentDay.format('M-DD-YYYY') === cycleDate.format('M-DD-YYYY')) {
          return true;
        }
      } else if (data === 'past3') {
        const past3Days = moment().subtract(4, 'days');
        return cycleDate.isAfter(past3Days) && cycleDate.isBefore(currentDay);
      } else if (data === 'past7') {
        const past3Days = moment().subtract(8, 'days');
        return cycleDate.isAfter(past3Days) && cycleDate.isBefore(currentDay);
      } else if (data === 'week') {
        return cycleDate.isSame(currentDay, 'week');
      } else if (data === 'month') {
        return cycleDate.isSame(currentDay, 'month');
      } else if (data === 'past30') {
        const past30Days = moment().subtract(30, 'days');
        return cycleDate.isAfter(past30Days) && cycleDate.isBefore(currentDay);
      } else if (data === '3') {
        const monthAgo = moment().subtract(3, 'months');
        return cycleDate.isAfter(monthAgo) && cycleDate.isBefore(currentDay);
      } else if (data === '6') {
        const monthAgo = moment().subtract(6, 'months');
        return cycleDate.isAfter(monthAgo) && cycleDate.isBefore(currentDay);
      }
      return false;
    });
  }

  if (field === 'deviceDate') {
    if (data === 'hour') {
      const sensorId = [];
      const allSensors = [];
      for (let i = 0; i < list.length; i += 1) {
        if (!sensorId.includes(list[i].did)) {
          sensorId.push(list[i].did);
          allSensors.push(list[i]);
        } else {
          break;
        }
      }
      return allSensors;
    }
    return list.filter((item) => {
      const currentDay = moment();
      const deviceDate = moment(item.startTime || item.endTime);
      if (data === 'today') {
        return currentDay.format('M-DD-YYYY') === deviceDate.format('M-DD-YYYY');
      }
      if (data === 'yesterday') {
        currentDay.subtract(1, 'days');
        return currentDay.format('M-DD-YYYY') === deviceDate.format('M-DD-YYYY');
      }
      if (data === 'week') {
        const sevenDaysAgo = moment().subtract(7, 'days');
        return deviceDate.isAfter(sevenDaysAgo) && deviceDate.isBefore(currentDay);
      }
      if (data === 'month') {
        const thirtyDaysAgo = moment().subtract(30, 'days');
        return deviceDate.isAfter(thirtyDaysAgo) && deviceDate.isBefore(currentDay);
      }
      if (data === '60') {
        const sixtyDaysAgo = moment().subtract(60, 'days');
        return deviceDate.isAfter(sixtyDaysAgo) && deviceDate.isBefore(currentDay);
      }
      return true;
    });
  }

  if (field === 'cycleRange') {
    const {
      start,
      end,
    } = data;

    const startDate = moment(start);
    const endDate = moment(end).endOf('day');
    return list.filter((item) => {
      const cycleDate = moment(item.startTime || item.endTime);
      if (startDate.format('M-D-YY') === endDate.format('M-D-YY')) {
        return cycleDate.format('MM-D-YYYY') === startDate.format('MM-D-YYYY');
      }
      return cycleDate.isAfter(startDate) && cycleDate.isBefore(endDate);
    });
  }

  if (field === 'cycleLength') {
    return list.filter((item) => {
      if (item.cycle) {
        const fifteenMin = 15 * 60;
        const thirtyMin = 30 * 60;
        const oneHour = 60 * 60;
        if (data === '1') {
          return item.cycle.cycleTimeSeconds <= fifteenMin;
        }
        if (data === '2') {
          return item.cycle.cycleTimeSeconds <= thirtyMin
            && item.cycle.cycleTimeSeconds > fifteenMin;
        }
        if (data === '3') {
          return item.cycle.cycleTimeSeconds <= oneHour && item.cycle.cycleTimeSeconds > thirtyMin;
        }
        if (data === '4') {
          return item.cycle.cycleTimeSeconds > oneHour;
        }
      }
      return false;
    });
  }

  if (field === 'orderStatus') {
    return list.filter((item) => {
      let count = 0;
      let openCounter = 0;
      let error = false;
      if (item.orderLine) {
        item.orderLine.forEach((oL) => {
          if (oL.status === 'Error') {
            error = true;
          }
          if (oL.status === 'Shipped' || oL.status === 'Delivered') {
            count += 1;
          }
          if (oL.status === 'Open') {
            openCounter += 1;
          }
        });
      }
      if (data === 'Error') {
        return error;
      }
      if (data === 'No items shipped') {
        return openCounter === item.orderLine.length;
      }
      if (data === 'Pending fulfillment') {
        return count === 0;
      }
      if (data === 'Partially shipped') {
        return count > 0 && count < item.orderLine.length;
      }
      if (data === 'All items shipped') {
        return count === item.orderLine.length && item.orderLine.length > 0;
      }
      return false;
    });
  }

  if (field === 'orderDate') {
    return list.filter((item) => {
      const orderDate = moment(item.orderDate).format('M-DD-YYYY');
      const filterDate = moment(data).format('M-DD-YYYY');
      return orderDate === filterDate;
    });
  }

  if (field === 'shipDate') {
    return list.filter((item) => {
      const filterDate = moment(data).format('YYYY-MM-DD');

      return item.shipDate === filterDate;
    });
  }

  if (field === 'orderRange') {
    const {
      start,
      end,
    } = data;

    const startDate = moment(start);
    const endDate = moment(end).endOf('day');

    return list.filter((item) => {
      const orderDate = moment(item.orderDate);
      if (startDate.format('M-D-YY') === endDate.format('M-D-YY')) {
        return orderDate.format('MM-D-YYYY') === startDate.format('MM-D-YYYY');
      }
      return orderDate.isAfter(startDate) && orderDate.isBefore(endDate);
    });
  }

  if (field === 'deviceId') {
    return list.filter(item => data === item.did);
  }

  if (field === 'deviceOffline') {
    return list.filter((item) => {
      if (data === '2') {
        return item.offlineDuration >= 2 && item.offlineDuration < 12;
      }
      if (data === '12') {
        return item.offlineDuration >= 12 && item.offlineDuration < 24;
      }
      if (data === 'day') {
        return item.offlineDuration >= 24 && item.offlineDuration < 72;
      }
      if (data === 'threeDays') {
        return item.offlineDuration >= 72;
      }
      return true;
    });
  }

  if (field === 'deviceUplink') {
    return list.filter((item) => {
      if (data === '95') {
        return item.status.ratio >= 0.95;
      }
      if (data === '75') {
        return item.status.ratio >= 0.75 && item.status.ratio < 0.95;
      }
      if (data === '50') {
        return item.status.ratio >= 0.50 && item.status.ratio < 0.75;
      }
      if (data === '25') {
        return item.status.ratio >= 0.25 && item.status.ratio < 0.50;
      }
      return true;
    });
  }

  if (field === 'deviceCombined') {
    return list.filter((item) => {
      if (data === '95') {
        return item.combinedRatio >= 0.95;
      }
      if (data === '90') {
        return item.combinedRatio >= 0.90 && item.combinedRatio < 0.95;
      }
      if (data === '75') {
        return item.combinedRatio >= 0.75 && item.combinedRatio < 0.90;
      }
      if (data === '0') {
        return item.combinedRatio < 0.75;
      }
      return true;
    });
  }

  if (field === 'deviceComfort') {
    return list.filter(item => item.sensors.reduce((acc, s) => {
      const {
        sensor: {
          zone,
        },
        status: {
          ratio,
        },
      } = s;
      let result = acc;

      if (zone === 'Supply Air') {
        if (data === '95' && ratio >= 0.95) {
          result = true;
        }
        if (data === '90' && ratio >= 0.90 && ratio < 0.95) {
          result = true;
        }
        if (data === '75' && ratio >= 0.75 && ratio < 0.90) {
          result = true;
        }
        if (data === '0' && ratio < 0.75) {
          result = true;
        }
      }
      return result;
    }, false));
  }

  if (field === 'deviceFilter') {
    return list.filter(item => item.sensors.reduce((acc, s) => {
      const {
        sensor: {
          zone,
        },
        status: {
          ratio,
        },
      } = s;
      let result = acc;

      if (zone === 'Room Ambient') {
        if (data === '95' && ratio >= 0.95) {
          result = true;
        }
        if (data === '90' && ratio >= 0.90 && ratio < 0.95) {
          result = true;
        }
        if (data === '75' && ratio >= 0.75 && ratio < 0.90) {
          result = true;
        }
        if (data === '0' && ratio < 0.75) {
          result = true;
        }
      }
      return result;
    }, false));
  }

  if (field === 'deviceWater') {
    return list.filter(item => item.sensors.reduce((acc, s) => {
      const {
        sensor: {
          zone,
        },
        status: {
          ratio,
        },
      } = s;
      let result = acc;

      if (zone === 'Attic') {
        if (data === '95' && ratio >= 0.95) {
          result = true;
        }
        if (data === '90' && ratio >= 0.90 && ratio < 0.95) {
          result = true;
        }
        if (data === '75' && ratio >= 0.75 && ratio < 0.90) {
          result = true;
        }
        if (data === '0' && ratio < 0.75) {
          result = true;
        }
      }
      return result;
    }, false));
  }

  function escapeRegExp(s) {
    return s.replace(/[-/\\^$*+?.()|[\]{}]/g, '\\$&');
  }
  const words = data
    .split(/\s+/g)
    .map(s => s.trim())
    .filter(s => !!s);
  const hasTrailingSpace = data.endsWith(' ');
  const searchRegex = new RegExp(
    words
      .map((word, i) => {
        if (i + 1 === words.length && !hasTrailingSpace) {
          // The last word - ok with the word being "startswith"-like
          return `(?=.*\\b${escapeRegExp(word)})`;
        }
        // Not the last word - expect the whole word exactly
        return `(?=.*\\b${escapeRegExp(word)}\\b)`;
      })
      .join('') + '.+',
    'gi',
  );

  if (field === 'corporationName') {
    return list.filter(item => searchRegex.test(item.corporationName));
  }

  if (field === 'email') {
    return list.filter((item) => {
      if (item.email) {
        return searchRegex.test(item.email);
      }
      if (item.customer) {
        return searchRegex.test(item.customer.email);
      }
      if (item.corporation) {
        return searchRegex.test(item.corporation.email);
      }
      return false;
    });
  }

  if (field === 'phone') {
    return list.filter(item => searchRegex.test(item.phone));
  }

  if (field === 'lastName') {
    return list.filter(item => searchRegex.test(item.lastName));
  }

  if (field === 'partnerAddress') {
    return list.filter(item => searchRegex.test(item.address1)
      || searchRegex.test(item.address2)
      || searchRegex.test(item.city)
      || searchRegex.test(item.state)
      || searchRegex.test(item.zip));
  }

  if (field === 'account' || field === 'name') {
    return list.filter((item) => {
      if (item.customer) {
        return searchRegex.test(item.customer.firstName)
          || searchRegex.test(item.customer.lastName)
          || searchRegex.test(`${item.customer.firstName} ${item.customer.lastName}`)
          || searchRegex.test(`${item.customer.lastName} ${item.customer.firstName}`);
      }
      if (item.corporation) {
        return searchRegex.test(item.corporation.firstName)
          || searchRegex.test(item.corporation.lastName)
          || searchRegex.test(`${item.corporation.firstName} ${item.corporation.lastName}`)
          || searchRegex.test(`${item.corporation.lastName} ${item.corporation.firstName}`);
      }
      return false;
    });
  }

  if (field === 'uid') {
    return list.filter(item => data === item.uid);
  }

  if (field === 'supplyDId') {
    return list.filter(item => item.supplyAir.deviceId.includes(data));
  }

  if (field === 'zone') {
    return list.filter((item) => {
      let include = false;

      item.hvac.forEach((hvac) => {
        if (hvac && searchRegex.test(hvac.zone)) {
          include = true;
        }
      });

      return include;
    });
  }

  if (field === 'address') {
    return list.filter(item => searchRegex.test(item.customer.serviceAddress[0].address1)
      || searchRegex.test(item.customer.serviceAddress[0].address2)
      || searchRegex.test(item.customer.serviceAddress[0].city)
      || searchRegex.test(item.customer.serviceAddress[0].state)
      || searchRegex.test(item.customer.serviceAddress[0].zip));
  }

  if (field === 'shippingAddress') {
    return list.filter(item => item.shippingAddress.address1.includes(data)
      || item.shippingAddress.address2.includes(data)
      || item.shippingAddress.city.includes(data)
      || item.shippingAddress.state.includes(data)
      || item.shippingAddress.zip.includes(data));
  }

  if (field === 'tracking') {
    return list.filter((item) => {
      if (item.trackingNumber) {
        const tracking = JSON.parse(item.trackingNumber);
        return tracking[0].trackingnumber.includes(data.toUpperCase());
      }
      return false;
    });
  }

  if (field === 'orderNumber') {
    return list.filter(item => item.orderNumber.toString().includes(data));
  }

  if (field === 'alertReason') {
    if (data === 'deltaT') {
      return list.filter((item) => {
        let include = false;
        item.notifications.forEach((noti) => {
          if (noti.category === 'DELTA_T') {
            include = true;
          }
        });
        return include;
      });
    }
    if (data === 'supply') {
      return list.filter(item => item.notification.category === 'SUPPLY_AIR');
    }
    if (data === 'offline') {
      return list.filter(item => item.notification.strength === 'OFFLINE');
    }
    if (data === 'weak') {
      return list.filter(item => item.notification.strength === 'WEAK');
    }
    if (data === 'fair') {
      return list.filter(item => item.notification.strength === 'FAIR');
    }

    return list;
  }

  if (field === 'communication') {
    return list.filter((item) => {
      let include = false;
      item.status.forEach((sta) => {
        if (data === 'offline') {
          if (sta.countReal === 0) {
            include = true;
          }
        } else if (data === 'weak') {
          if (sta.ratio < 0.50 && sta.countReal !== 0) {
            include = true;
          }
        } else if (data === 'fair' && sta.countReal !== 0) {
          if (sta.ratio < 0.80) {
            include = true;
          }
        } else if (data === 'online' && sta.countReal !== 0) {
          if (sta.ratio >= 0.8) {
            include = true;
          }
        }
      });

      return include;
    });
  }

  if (field === 'strength') {
    return list.filter((item) => {
      const {
        status: {
          ratio,
        },
      } = item;
      if (data === 'strong') {
        if (ratio >= 0.95) {
          return true;
        }
      } else if (data === 'good') {
        if (ratio >= 0.8 && ratio < 0.95) {
          return true;
        }
      } else if (data === 'fair') {
        if (ratio >= 0.5 && ratio < 0.8) {
          return true;
        }
      } else if (data === 'weak') {
        if (ratio < 0.5 && ratio > 0) {
          return true;
        }
      } else if (data === 'offline') {
        if (ratio === 0) {
          return true;
        }
      }
      return false;
    });
  }

  if (field === 'percent') {
    return list.filter((item) => {
      const {
        ratio,
      } = item;
      if (data === '1') {
        if (ratio >= 0.95) {
          return true;
        }
      } else if (data === '2') {
        if (ratio < 0.95 && ratio >= 0.8) {
          return true;
        }
      } else if (data === '3') {
        if (ratio < 0.8 && ratio >= 0.5) {
          return true;
        }
      } else if (data === '4') {
        if (ratio < 0.5) {
          return true;
        }
      }
      return false;
    });
  }

  return list;
};

export default filterList;
